import { useMutation } from '@tanstack/react-query';
import { OrganizationDto, UpdateOrganizationRefundDeadlineDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateOrganizationRefundDeadline = (organizationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationRefundDeadline', organizationId],
        mutationFn: (body: UpdateOrganizationRefundDeadlineDto) => apiClient.fetchApi<OrganizationDto, UpdateOrganizationRefundDeadlineDto>({ method: 'POST', endpoint: `organizations/${organizationId}/refundDeadline`, body }),
        onSuccess: (data) => {
            onSuccess();
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};